import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/view/components/ui/form'
import { Button } from '@/view/components/ui/button'
import { Input } from '@/view/components/ui/input'
import {
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/view/components/ui/dialog'
import { useAuth } from '@/app/hooks/useAuth'

const formSchema = z.object({
  oldPassword: z.string().optional(),
})

type FormValues = z.infer<typeof formSchema>

interface DeletePinFormProps {
  isPending: boolean
  onSubmit: (data: { pin: string[]; oldPassword?: string }) => Promise<void>
}

export function DeletePinForm({ isPending, onSubmit }: DeletePinFormProps) {
  const { isAdmin } = useAuth()
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      oldPassword: '',
    },
  })

  const handleSubmit = (values: FormValues) => {
    onSubmit({ pin: [], oldPassword: values.oldPassword })
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
        <DialogHeader>
          <DialogTitle className="text-center text-xl font-semibold">
            Apagar PIN
          </DialogTitle>
        </DialogHeader>

        {isAdmin ? (
          <p>Tem certeza que deseja apagar este PIN?</p>
        ) : (
          <FormField
            control={form.control}
            name="oldPassword"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-sm font-bold">
                  Insira sua senha
                </FormLabel>
                <FormControl>
                  <Input
                    type="password"
                    className="my-2 h-11 border-[1px] border-black04 font-medium placeholder:text-black04"
                    placeholder="Insira sua senha atual"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}

        <DialogFooter className="space-x-2">
          <Button type="submit" disabled={isPending} className="text-white">
            Apagar
          </Button>
        </DialogFooter>
      </form>
    </Form>
  )
}
